import TasksLogs from "Areas/SharedFeatures/tasksLogs";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import { taskStatusColorMap, taskStatusIconMap, taskStatusLocale } from "Common/dictionaries/taskStatus";
import DataGridBase, { DateTimeCell, TextCell } from "Components/dataGridBase";
import ProgressOverlay from "Components/progressOverlay";
import { IWithTooltip } from "Components/withPopover";
import classNames from "classnames";
import { Column } from "devextreme-react/data-grid";
import get from "lodash/get";
import isNumber from "lodash/isNumber";
import React, { useCallback, useMemo, useRef, useState } from "react";
import locale from "./tasksTable.locale";
const statusPopoverContent = (status) => (React.createElement("div", { className: "font-small pt-0_25 pb-0_25 pl-0_5 pr-0_5" }, taskStatusLocale[status]));
const filterBuilderFields = [
    {
        dataField: "Name",
        dataType: "string",
        caption: locale.TASK_NAME
    },
    {
        dataField: "NodeDescription",
        dataType: "string",
        caption: locale.SEARCH_CRITERIA
    },
    {
        dataField: "MethodName",
        dataType: "string",
        caption: locale.METHOD
    },
    {
        dataField: "Created",
        dataType: "date",
        caption: locale.CREATED
    },
    {
        dataField: "UserCreatedName",
        dataType: "string",
        caption: locale.AUTHOR
    },
    {
        dataField: "DocumentName",
        dataType: "string",
        caption: locale.DOCUMENT
    }
];
const renderTaskStatus = ({ displayValue }) => (React.createElement(IWithTooltip, { className: classNames(taskStatusIconMap[displayValue], taskStatusColorMap[displayValue], "h-max-content", "w-max-content", "font-h5", "d-block"), popoverContent: statusPopoverContent(displayValue), popoverClassName: "no-popover-arrow" }));
export default function TasksTable(props) {
    const gridRef = useRef(null);
    const [count, setCount] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const renderTaskLogsIcon = useCallback(({ data }) => (React.createElement(IWithTooltip, { className: "icon-inputlog animate-hover-color clickable font-h5 d-block", popoverContent: React.createElement("div", { className: "font-small pt-0_25 pb-0_25 pl-0_5 pr-0_5" }, locale.WATCH_TASK_LOGS), popoverClassName: "no-popover-arrow", onClick: () => {
            props.onTaskLogOpen && props.onTaskLogOpen(true, [data.Id], data.Name);
        } })), [props.onTaskLogOpen]);
    const onDataHasChanged = (params) => {
        const totalCount = get(params, "response.totalCount");
        isNumber(totalCount) && setCount(totalCount);
    };
    const gridComponent = useMemo(() => props.loadUrl ? (React.createElement(DataGridBase, { gridRef: gridRef, onHasDataChanged: onDataHasChanged, loadUrl: props.loadUrl, key: props.projectId || props.workspaceId || -1, remoteOperations: true, onContentReady: () => setIsLoading(false), filterBuilderFields: filterBuilderFields },
        React.createElement(Column, { dataField: "Status", dataType: "number", alignment: "left", caption: "", cellRender: renderTaskStatus, width: 44, allowHeaderFiltering: false, allowSorting: false, allowResizing: false, allowFiltering: false }),
        React.createElement(Column, { dataField: "Name", dataType: "string", caption: locale.TASK_NAME, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: "auto", minWidth: 100, allowHeaderFiltering: false }),
        React.createElement(Column, { dataField: "NodeDescription", dataType: "string", caption: locale.SEARCH_CRITERIA, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: "auto", minWidth: 100 }),
        React.createElement(Column, { dataField: "MethodName", dataType: "string", caption: locale.METHOD, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: "auto", minWidth: 100 }),
        React.createElement(Column, { allowHeaderFiltering: false, dataField: "Created", dataType: "date", sortOrder: SORT_ORDER.DESC, caption: locale.CREATED, cellRender: DateTimeCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: 180 }),
        React.createElement(Column, { dataField: "UserCreatedName", dataType: "string", caption: locale.AUTHOR, allowSorting: false, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: 180 }),
        React.createElement(Column, { dataField: "DocumentName", dataType: "string", caption: locale.DOCUMENT, cellRender: TextCell, editorOptions: { placeholder: locale.FILTER_TEXT }, width: 180 }),
        React.createElement(Column, { type: "buttons", allowHeaderFiltering: false, caption: "", cellRender: renderTaskLogsIcon, allowSorting: false, allowResizing: false, allowFiltering: false, width: 44 }))) : null, [props.projectId, props.workspaceId]);
    return (React.createElement(ProgressOverlay, { show: isLoading },
        React.createElement("div", { className: "h-100" },
            React.createElement("div", { className: classNames(!isNumber(count) && "invisible", "w-fit-content mb-1 text-muted bg-gray-100 border-rounded-base pr-0_5 pl-0_5") }, locale.buildCountTasksTitle(count || 0)),
            gridComponent,
            React.createElement(TasksLogs, null))));
}
